import { useMemo, useState, useCallback } from 'react'
import { isCollapsed , getNextIndex, getPreviousIndex, isPointAtWordEnd, getNodeDeserializer } from '@udecode/slate-plugins'
import { Transforms, Range } from 'slate'
import { useTranslation } from 'react-i18next'

import { isWordAfterTrigger } from '../../editor-utils';
import { insertVariable } from './transforms/insert-variable'

import { agendaFields } from 'components/Modals/AgendaModal'

function addTestamentProperties(participant, constants, { t }) {
  if (['testator', 'executor', 'witness'].includes(participant.testamentRole)) {
    constants.push({ name: t('contracts.constants.properties.maritalStatus'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.maritalStatus' })
    constants.push({ name: t('contracts.constants.properties.address.zipCode'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.address.zipCode' })
    constants.push({ name: t('contracts.constants.properties.address.street'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.address.street' })
    constants.push({ name: t('contracts.constants.properties.address.externalNumber'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.address.exteriorNumber' })
    constants.push({ name: t('contracts.constants.properties.address.internalNumber'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.address.interiorNumber' })
    constants.push({ name: t('contracts.constants.properties.address.state'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.address.state' })
    constants.push({ name: t('contracts.constants.properties.address.municipio'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.address.municipio' })
  }
  if (['testator', 'witness'].includes(participant.testamentRole)) {
    constants.push({ name: t('contracts.constants.properties.nationality'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.nationality' })
    constants.push({ name: t('contracts.constants.properties.birthDate'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.birthDate' })
  }
  if (['testator'].includes(participant.testamentRole)) {
    constants.push({ name: t('contracts.constants.properties.officialIdentificationNumber'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.officialIdentificationNumber' })
    constants.push({ name: t('contracts.constants.properties.birthplace'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.birthplace' })
  }
  if (['testator', 'executor', 'legatee', 'witness'].includes(participant.testamentRole)) {
    constants.push({ name: t('CURP'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.curp' })
  }
  if (['legatee'].includes(participant.testamentRole)) {
    constants.push({ name: t('contracts.constants.properties.legacyDescription'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.legacyDescription' })
  }
  // constants.push({ name: t('Porcentaje de la masa hereditaria'), value: '', type: 'constant', _id: participant._id, apiName: 'properties.percentageOfInheritanceState' })
}


function addAgendaProperties(participant, constants, { t }) {
  agendaFields.map(field => {
    constants.push({ name: t(`agenda.${field.propertyName}_placeholder`), value: '', type: 'constant', _id: participant._id, apiName: `agendaProperties.${field.propertyName}` })
  })
}



export const useVariables = (
  participants = [],
  { maxSuggestions = 5, trigger = '@',  jurisdiction, isTestament, hasZoom, ...options } = {}
) => {
  const { t } = useTranslation()
  const [targetRange, setTargetRange] = useState(null);
  const [valuePath, setValuePath] = useState([0, 0]);
  const [search, setSearch] = useState('');
  const values = useMemo(() => {
      const searchTerm = search.toLowerCase().replace(/_/g, ' ');
      const participantVariables = participants.reduce(((options, participant, i) => {
        let constants = [
          { name: t('contracts.constants.signedAt'), value: '', type: 'constant', _id: participant._id, apiName: 'signedAt' },
          { name: t('contracts.constants.obligation'), value: '', type: 'constant', _id: participant._id, apiName: 'obligation' },
          { name: t('contracts.constants.label'), value: '', type: 'constant', _id: participant._id, apiName: 'label' },
          { name: t('contracts.constants.email'), value: '', type: 'constant', _id: participant._id, apiName: 'email' },
          { name: t('contracts.constants.phone'), value: '', type: 'constant', _id: participant._id, apiName: 'phone' },
      ]


        if (jurisdiction === 'pr') {
          constants.push({ name: 'DNI/C.E./otro', value: '', type: 'constant', id: participant._id, apiName: 'cpf' })
          constants.push({ name: 'Cargo', value: '', type: 'constant', id: participant._id, apiName: 'cargo' })
        }
        if (jurisdiction === 'co') {
          constants.push({ name: 'Cédula no.', value: '', type: 'constant', id: participant._id, apiName: 'cpf' })
        }
        if (jurisdiction === 'br') {
          constants.push({ name: 'Cargo', value: '', type: 'constant', id: participant._id, apiName: 'cargo' })
          constants.push({ name: 'RG', value: '', type: 'constant', id: participant._id, apiName: 'rg' })
          constants.push({ name: 'CPF', value: '', type: 'constant', id: participant._id, apiName: 'cpf' })
        }

        if (participant.obligation === 'legal') {
          constants.push({ name: t('contracts.constants.company_name'), value: '', type: 'constant', _id: participant._id, apiName: 'name' })
          constants.push({ name: t('contracts.constants.representative'), value: '', type: 'constant', _id: participant._id, apiName: 'representative' })
        } else {
          constants.push({ name: t('contracts.constants.name'), value: '', type: 'constant', _id: participant._id, apiName: 'name' })
          constants.push({ name: t('contracts.constants.last_name'), value: '', type: 'constant', _id: participant._id, apiName: 'last_name' })
        }
        
        if (isTestament) {
          addTestamentProperties(participant, constants, { t })
        }
        if (!isTestament) {
          addAgendaProperties(participant, constants, { t })
        }
        if (hasZoom) {
          constants.push({ name: t('Id de la reunion de Zoom'), value: '', type: 'constant', _id: participant._id, apiName: 'zoom.meeting.id' })
        }
        constants = constants.filter(c => c.name.toLowerCase().includes(searchTerm) || searchTerm.startsWith('pro'))


        const variables = participant.variables.map((variable) => {
          
          return { 
            name: variable.name, 
            _id: variable._id, 
            type: variable.type, 
            value: variable.value, 
            apiName: variable.apiName
          }
        }).filter(v => v.name.toLowerCase().includes(searchTerm) && v.apiName.length)

       const matched = variables.some(v => v.name.toLowerCase() === searchTerm);

        options.push({
          entity: 'participant',
          label: participant.label,
          participantId: participant._id,
          participantIndex: i + 1,
          matched,
          options: [
            ...variables,
            ...constants
          ].slice(0, maxSuggestions)
        })
        return options
      }), []);

      const contractProperties = {
        entity: 'contract',
        label: 'ContractProperties',
        options: [
          { name: t('editor.variables.popup_properties_docname'), value: '', type: 'constant', _id: 'contract', apiName: 'name' },
          { name: t('editor.variables.popup_properties_docid'), value: '', type: 'constant', _id: 'contract', apiName: 'documentId' },
          { name: t('editor.variables.popup_properties_signdate'), value: '', type: 'constant', _id: 'contract', apiName: 'signedAt' },
         
        ]
      }

      if (isTestament) {
        contractProperties.options.push({ name: t('contracts.constants.testamentHeirsNames'), value: '', type: 'constant', _id: 'contract', apiName: 'testamentHeirsNames' })
        // contractProperties.options.push({ name: t('contracts.constants.testamentWitnessesNames'), value: '', type: 'constant', _id: 'contract', apiName: 'testamentWitnessesNames' })
      } else {
        contractProperties.options.push({ name: t('editor.variables.popup_properties_externalId'), value: '', type: 'constant', _id: 'contract', apiName: 'externalId' })
      }

      return [
        ...participantVariables,
        contractProperties
      ]
  }, [participants, t, search, maxSuggestions])

  const onAddVariable = useCallback(
    (editor, data) => {
      if (targetRange !== null) {
        Transforms.select(editor, targetRange);
        insertVariable(editor, data, options);
        return setTargetRange(null);
      }
    },
    [options, targetRange]
  );

  const onKeyDownVariable = useCallback(
    (e, editor) => {
      const [entityIndex, optionIndex] = valuePath;
      const entity = values[entityIndex];
      const entityOptions = entity.options;
      if (targetRange) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          return setValuePath(getNextIndex(optionIndex, entityOptions.length - 1));
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          return setValuePath(getPreviousIndex(optionIndex, entityOptions.length - 1));
        }
        if (e.key === 'Escape') {
          e.preventDefault();
          return setTargetRange(null);
        }

        if (['Tab', 'Enter'].includes(e.key)) {
          e.preventDefault();
          onAddVariable(editor, entityOptions[optionIndex]);
          return false;
        }
      }
    },
    [
      values,
      valuePath,
      setValuePath,
      targetRange,
      setTargetRange,
      onAddVariable,
    ]
  );

  const onChangeVariable = useCallback(
    (editor) => {
      const { selection } = editor;

      if (selection && isCollapsed(selection)) {
        const cursor = Range.start(selection);

        const { range, match: beforeMatch } = isWordAfterTrigger(editor, {
          at: cursor,
          trigger,
          spaceChar: '_'
        });

        if (beforeMatch && isPointAtWordEnd(editor, { at: cursor })) {
          setTargetRange(range);
          const [, word] = beforeMatch;
          setSearch(word);
          setValuePath([0, 0]);
          return;
        }
      }

      setTargetRange(null);
    },
    [setTargetRange, setSearch, setValuePath, trigger]
  );

  return {
    search,
    path: valuePath,
    target: targetRange,
    values,
    onChangeVariable,
    onKeyDownVariable,
    onAddVariable,
  };
};